import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'multireducer';
import { increment } from 'redux/modules/counter';
var CounterButton = (_dec = connect(function (state, _ref) {
  var key = _ref.multireducerKey;
  return {
    count: state.counter[key].count
  };
}, function (dispatch, _ref2) {
  var key = _ref2.multireducerKey;
  return bindActionCreators({
    increment: increment
  }, dispatch, key);
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(CounterButton, _Component);

  var _super = _createSuper(CounterButton);

  function CounterButton() {
    _classCallCheck(this, CounterButton);

    return _super.apply(this, arguments);
  }

  _createClass(CounterButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          count = _this$props.count,
          increment = _this$props.increment; // eslint-disable-line no-shadow

      var className = this.props.className;
      className += ' btn btn-default';
      return /*#__PURE__*/React.createElement("button", {
        className: className,
        onClick: increment
      }, "You have clicked me ", count, " time", count === 1 ? '' : 's', ".");
    }
  }]);

  return CounterButton;
}(Component), _defineProperty(_class2, "propTypes", {
  count: PropTypes.number,
  increment: PropTypes.func.isRequired,
  className: PropTypes.string
}), _defineProperty(_class2, "defaultProps", {
  className: ''
}), _temp)) || _class);
export { CounterButton as default };